import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderCheckmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 67,
	height: 61,
	fill: "none",
	viewBox: "0 0 67 61",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 56,
			height: 50,
			x: 10.8,
			y: 10.4,
			fill: "#AAFBB2",
			fillOpacity: .2,
			rx: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#66956A",
			strokeLinecap: "round",
			strokeWidth: 2,
			d: "M38 25.3H24.8A4 4 0 0 0 21 28l-1.4 4.2a4 4 0 0 1-3.8 2.7h-2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2C2B2B",
			d: "M29.2 34.7h-18v21.4c1 2.7 2.2 3.5 4.8 4.1h45.8c2.7-1 3.6-2 4.5-4.4v-21l-7 .4-3.5-2-1.5-5.7-3.5-2h-14l-3.5 2-1.2 4.3-2.9 3Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 55,
			height: 49,
			x: 11.1,
			y: 10.9,
			stroke: "#AAFBB2",
			rx: 4.5
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#AAFBB2",
			strokeLinecap: "square",
			strokeWidth: 2,
			d: "M64.6 34.9h-4.8A4 4 0 0 1 56 32l-1.3-4a4 4 0 0 0-3.8-2.8H37.2a4 4 0 0 0-3.8 2.7L32 32.2a4 4 0 0 1-3.8 2.7H12.6"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 37.1,
			cy: 30.1,
			r: 1.2,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 25.6,
			cy: 30.1,
			r: 1.2,
			fill: "#66956A"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 11.7,
			height: 2.4,
			x: 40.2,
			y: 28.9,
			fill: "#fff",
			rx: 1
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 11.3,
			r: 10.7,
			fill: "#6D9E72"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeLinecap: "round",
			strokeWidth: 2,
			d: "m6.6 12.2 3 2.4c.3.4 1 .3 1.3-.1l5.2-6.6"
		})
	]
});
export default SvgFolderCheckmark;
